import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import Null from '@ms/yammer-libs-null';

export const LoadableToaster = lazyLoadOnRender({
  loader: () =>
    import(/* webpackChunkName: "4-feat-toast" */ './Toast').then((module) => ({ default: module.Toaster })),
  loading: Null,
});
